import axios from 'axios';
import {backendHost} from '../../config';

export const updateUsersComments = (params) => {
    return axios.put(`${backendHost}/api/admin/v2/mailing/users/comments`, params);
};